import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import * as React from 'react';
import { AD_BANNER_MF_MANIFEST_SETTING_KEY } from 'shared/constants/microfrontends';
import { AdBannerMicrofrontendSeoTopContainer } from 'shared/containers/AdBannerMicrofrontendSeoTopContainer';
import { AdFoxBannerContainer } from 'shared/containers/AdFoxBannerContainer';
import { AdfoxContextProviderProps } from 'shared/utils/AdfoxContext';
import { useApplicationContext } from 'shared/utils/applicationContext';

const POST_VIEW_ANALYTICS_DATA: AdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'footer',
};
const P_PARAMS: AdfoxContextProviderProps['pParams'] = { p1: 'dbtyp', p2: 'y' };
const SIZE: AdfoxContextProviderProps['size'] = { width: '100%', height: 560 };

export const SeoTopBannersContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const manifest = config.get<IMicrofrontendManifest>(AD_BANNER_MF_MANIFEST_SETTING_KEY);

  const [isHidden, setIsHidden] = React.useState(false);
  const hide = React.useCallback(() => setIsHidden(true), []);

  if (manifest) {
    if (isHidden) {
      return null;
    }

    return <AdBannerMicrofrontendSeoTopContainer manifest={manifest} onStub={hide} onError={hide} onClose={hide} />;
  }

  return (
    <AdFoxBannerContainer
      size={SIZE}
      pParams={P_PARAMS}
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
      bannerName="Adfox ТГБ баннер в футере"
    />
  );
};
